export const tr = {
    billion: 'milyar',
    million: 'milyon',
    quadrillion: 'katrilyon',
    quintillion: 'kentilyon',
    thousand: 'bin',
    trillion: 'trilyon'
};
